import { TagManager } from '@navent-jobs/config'

export const PaginationDataLayers = {
  paginationOnUse: page => {
    /**
     * El objetivo es trackear cuando el usuario cambia de página para ver más avisos.
     */

    return TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Listado',
      eventAction: 'Paginado',
      eventLabel: `${page}`,
    })
  },
}
